import { useEffect, useState } from 'react'
import { F0Dialog } from '@factorialco/f0-react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { Text } from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const ImportFteModalPage = () => {
  const [open, setOpen] = useState(false)

  const navigate = useNavigate()
  const {
    state: { employeeIds },
  } = useLocation()
  const { navigation } = useNavigation()

  const { canSeeFinanceWorkspace } = useOutletContext<{
    canSeeFinanceWorkspace: boolean
  }>()

  const {
    access: { locale },
    company: { id: companyId },
  } = useCurrentSession()

  const onClose = useUnsafeCallback(() => {
    navigate(navigation.finance.financialWorkspace.employee_costs.fullPath())
  }, [navigate, navigation])

  useEffect(() => {
    if (!canSeeFinanceWorkspace) {
      onClose()
    }
  }, [canSeeFinanceWorkspace, onClose])

  if (!canSeeFinanceWorkspace) {
    return null
  }

  return (
    <>
      <F0Dialog
        width="sm"
        isOpen={!open}
        onClose={onClose}
        primaryAction={{
          onClick: () => setOpen(true),
          label: i18n.t('finance.financial_workspace.employee_costs.workforce.fte_dialog_yes'),
        }}
        secondaryAction={{
          onClick: onClose,
          label: i18n.t('finance.financial_workspace.employee_costs.workforce.fte_dialog_no'),
        }}
        title={i18n.t('finance.financial_workspace.employee_costs.workforce.fte_dialog_title')}
      >
        <Text.Normal>
          {i18n.t('finance.financial_workspace.employee_costs.workforce.fte_dialog_body')}
        </Text.Normal>
      </F0Dialog>
      {open && (
        <NuvoImporter
          isEdition
          locale={locale}
          companyId={companyId}
          importType="working_time_percentage_importer"
          metadata={{ employee_ids: employeeIds ?? [] }}
        />
      )}
    </>
  )
}

export default ImportFteModalPage
